module.exports = __webpack_public_path__ + "img/41.04d9c33f.jpg";